export const Column = {
  "background-color": "color",
  border: "string",
  "border-bottom": "string",
  "border-left": "string",
  "border-radius": "unit(px,%){1,4}",
  "border-right": "string",
  "border-top": "string",
  direction: "enum(ltr,rtl)",
  "inner-background-color": "color",
  "padding-bottom": "unit(px,%)",
  "padding-left": "unit(px,%)",
  "padding-right": "unit(px,%)",
  "padding-top": "unit(px,%)",
  "inner-border": "string",
  "inner-border-bottom": "string",
  "inner-border-left": "string",
  "inner-border-radius": "unit(px,%){1,4}",
  "inner-border-right": "string",
  "inner-border-top": "string",
  padding: "unit(px,%){1,4}",
  "vertical-align": "enum(top,bottom,middle)",
  width: "unit(px,%)",
};
